import rPeofessional from "@/components/r-peofessional";
import rDesignCustomer from "@/components/r-design-customer";
import rDressStyle from "@/components/r-dress-style";
import rMeasurements from "@/components/r-measurements";
import rButton from "@/components/r-button";
import rIptText from "@/components/r-ipt-text";

import {
  getFabric,
  getFabricStock,
  getArchivesData,
  getCategoryInfo,
  getUserCategory
} from "@/api/peofessional";
import {getCust} from "@/api/user";
import {
  listDictSystem,
  styleInfo,
  dictbasicList,
  specBody,
  standard,
  measureInfo,
  getFinishedSize
} from "@/api/dict";
import {submitCart, submitOrder, editOrder} from "@/api/cart";
import {getCategory} from "@/api/dict";
import {getParams, getBrowserLang} from "@/libs/util";

const SUITNUM = 2.54;
export default {
  components: {
    rPeofessional,
    rDesignCustomer,
    rDressStyle,
    rMeasurements,
    rButton,
    rIptText
  },
  data() {
    return {
      fixedActionShow: false,
      spinShow: false,
      params: {
        productId: "sys",
        fabric: ""
      },
      // stepId:1,
      // 产品列表
      productList: [
        {
          value: "sys",
          label: "MTM"
        },
        {
          value: "cus",
          label: "CMT"
        }
      ],
      //   步骤列表
      stepList: [
        {
          name: this.$t("newOrder.stepName.one"),
          step: 1
        },
        {
          name: this.$t("newOrder.stepName.two"),
          step: 2
        },
        {
          name: this.$t("newOrder.stepName.three"),
          step: 3
        },

        {
          name: this.$t("newOrder.stepName.five"),
          step: 4
        }
      ],
      // 基本信息列表
      basicList: [
        {
          label: this.$t("customer.basicList.name"),
          must: true,
          type: "autocomplete",
          inputValue: "",
          key: "customerName",
          customerName: "",
          remoteMethod: this.handRemoteCust,
          loading: false,
          list: []
        },
        {
          label: this.$t("customer.basicList.nickname"),
          must: true,
          type: "input",
          inputValue: "",
          key: "shortName"
        },
        {
          label: this.$t("customer.basicList.gender"),
          must: true,
          type: "iptSuit",
          inputValue: getBrowserLang() === "zh" ? "男" : "Male",
          key: "genderName",
          suitKey: "genderId",
          readonly: true,
          suitVal: 10040,
          list: []
        },
        {
          label: this.$t("customer.basicList.height"),
          must: true,
          inputValue: "",
          type: "iptSuit",
          key: "height",
          suitKey: "heightUnit",
          suitVal: null,
          list: []
        },
        {
          label: this.$t("customer.basicList.weight"),
          inputValue: "",
          must: false,
          type: "iptSuit",
          key: "weight",
          suitKey: "weightUnit",
          suitVal: 10260,
          list: []
        },
        {
          label: this.$t("customer.basicList.phone"),
          type: "input",
          inputValue: "",
          key: "phone"
        },
        {
          label: this.$t("customer.basicList.email"),
          must: false,
          type: "input",
          inputValue: "",
          key: "email"
        },
        {
          label: this.$t("customer.basicList.address"),
          must: false,
          type: "input",
          inputValue: "",
          key: "address"
        },
        {
          label: this.$t("customer.basicList.DOB"),
          must: false,
          type: "date",
          inputValue: "",
          key: "birthdate"
        },
        {
          label: this.$t("customer.basicList.note"),
          must: false,
          type: "input",
          inputValue: "",
          width: 932,
          placeholder:"Comments here won't be seen by the factory. For special requests, pls contact your Service Specialist.",
          key: "note"
        }
      ],
      loading: false, // 搜索loading
      routeParams: {}, //地址栏参数
      fabricList: [], // 面料列表
      fabricStock: null, // 面料库存
      categoryList: [],
      specBodyList: [], // 特体
      volumeList: [], // 量体方式
      dressStyleList: [], // 着装风格
      customer: {
        customerId: "", // 客户id
        customerName: "", // 客户名称
        shortName: "", // 昵称
        height: "", // height
        heightUnit: "", // 身高单位
        weight: "", // 体重
        weightUnit: "", // 体重单位
        phone: "", // 手机号
        email: "", // 邮箱
        remark: "", // 备注
        genderId: "", // 性别
        genderName: "",
        birthdate: "", // 生日
        address: "" // 地址
      },
      submitData: {
        orderId: "", // 订单号
        cusOrderCode: "", // 客户单号
        type: 8, //下单类型
        clothCategory: "", // 服装分类id
        amount: 1, // 数量
        addProduct: null, // 追加产品
        fabric: "", // 面料编码
        style: 20100, // 长短款
        sizeCategoryId: 10052, // 尺寸分类id
        sizeAreaId: null, // 号型大类id
        memo: "", // 订单备注
        bodyTypeList: [
          // 特体
        ],
        detailList: [
          // 订单明细
        ]
      },
      detailList: [],
      clothDetails: {
        clothCategory: "", //服装分类id
        styleId: "", // 着装风格id
        shape: "", // 号型
        embList: [], // 刺绣信息
        sizeList: [], // 尺寸信息
        craftList: [], // 工艺信息
        contrastSaveList: [] // 撞色信息
      },
      embItem: {
        // 刺绣
        site: null, // 位置
        color: null, // 颜色
        font: null, // 字体
        embSize: null, // 绣字大小
        embContent: "" // 内容
      },
      craftItem: {
        // 工艺信息
        craftId: null,
        content: "",
        file: null,
        fileName: "",
        href: ""
      },
      sizeItem: {
        // 尺码
        partId: null, // 部位id
        partValue: null, // 尺寸值id
        modifyValue: null // 调整值id
      },
      contrastItem: {
        // 撞色
        site: null, // 位置
        color: null // 颜色
      },
      styleTypeList: [], // 长短款列表
      specBodyImg: "", // 特体图片
      specBodyText: "", // 特体描述
      sizeTypeList: [],
      sizeList: [], // 尺码列表
      heightUnit: "厘米", // 身高单位
      unit: {
        heightUnitName: "厘米",
        heightUnit: 10266,
        weightUnit: 10261,
        weightUnitName: "千克"
      },
      matchingClothData: {}, // 匹配成衣
      standardSizeList: [], // 标准款尺码
      editDetails: [],
      lang: null,
      plList: [],
      plVal: null,
      userCraftList: [],
      basicCustomer: "",
      orderCode: '',
      blError: '',
      plData: {
        detailList: []
      },
      timestamp: Date.now()
    };
  },
  watch: {
    $route: {
      handler: async function (val, oldVal) {
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleFabricStock(){
      this.fabricStock = null
      // this.submitData.fabric = ''
    },
    // 远程搜索面料
    async handleRemoteFabric(query) {
      if (query) {
        try {
          let response = await getFabric({
            clothCategory: this.routeParams.id,
            keywords: query
          });
          this.fabricList = response.data.data;
        } catch (error) {
        }
      } else {
        this.fabricList = [];
      }
    },
    handleFabricQueryChange(query) {
      if (!query) {
        this.$refs["fabricRef"].setQuery(null);
        this.$refs["fabricRef"].clearSingleSelect();
        this.fabricList = [];
        this.submitData.fabric = null;
        return false;
      }
    },
    //面料选择
    async handleFabricChange(val) {
      if (!val) return false;
      try {
        let response = await getFabricStock({
          fabricCode: val
        });

        this.fabricStock = response.data.data;
      } catch (error) {
      }
    },
    // 面料清空
    handleFabricClear() {
      this.fabricList = [];
      this.fabricStock = null;
    },
    // 删除所选面料
    handleFabricDel() {
      this.categoryList.map(item => {
        this.$set(item, "craftList", []);
      });
    },

    async handleCategoryData(categoryData) {
      this.categoryList = categoryData;
      let embList = [];
      let contrastSaveList = [];
      embList.push(JSON.parse(JSON.stringify(this.embItem)));
      contrastSaveList.push(JSON.parse(JSON.stringify(this.contrastItem)));
      this.categoryList.map((item, index) => {
        let craftList = [];
        this.clothDetails.clothCategory = item.id;
        if (this.userCraftList.length > 0) {
          let craftItem = this.userCraftList.find(
            userCraftItem => item.id === Number(userCraftItem.clothId)
          );
          craftList = craftItem.list || [];
        }
        this.detailList.push(JSON.parse(JSON.stringify(this.clothDetails)));
        this.$set(item, "CraftsList", []);
        this.$set(item, "craftVal", null);
        this.$set(item, "craftList", JSON.parse(JSON.stringify(craftList)));
        this.$set(item, "embList", JSON.parse(JSON.stringify(embList)));
        this.$set(
          item,
          "contrastSaveList",
          JSON.parse(JSON.stringify(contrastSaveList))
        );
      });
    },
    handleCustomerBaseInfo(category, sexData) {
      // 性别
      if (category === 10) {
        this.handleGender(sexData);
        // 体重单位
      } else if (category === 29) {
        this.handleWeightSuit(sexData);
        // 身高单位
      } else if (category === 30) {
        this.handleHeightSuit(sexData);
      }
    },
    // 匹配成衣
    async handleMatchingCloth() {
      this.spinShow = true;
      try {
        if (!this.handleValidateSubmit()) {
          this.spinShow = false;
          return false;
        }
        this.handleSubmitCraft();
        this.handleSubmitEmbs();
        this.handleSubmitContrast();
        this.handleSubmitCustomer();
        this.handleSubmitSize();
        this.handleSubmitSpecBody();
        this.submitData.detailList = this.detailList;
        this.submitData.onlySize='1';
        this.submitData = Object.assign(this.submitData, this.customer);
        let response = await getFinishedSize(this.submitData);
        let {code, data} = response.data;
        if (code === 0) {
          this.spinShow = false;
          this.matchingClothData = data;
        }
      } catch (error) {
        this.spinShow = false;
      }
    },
    // 处理性别
    handleGender(genderData) {
      let genderItem = this.basicList.find(item => {
        return item.key === "genderName";
      });
      if (undefined !== this.categoryList[0].ecode && this.categoryList[0].ecode.startsWith("W")) {
        genderItem.inputValue = getBrowserLang() === "zh" ? "女" : "Female";
        genderItem.suitVal = 10041;
      }
      this.$set(genderItem, "list", genderData);
    },
    // 处理体重单位
    handleWeightSuit(suitData) {
      let weightItem = this.basicList.find(item => {
        return item.key === "weight";
      });
      this.$set(weightItem, "list", suitData);
    },
    // 处理身高单位
    handleHeightSuit(suitData) {
      let heigthItem = this.basicList.find(item => {
        return item.key === "height";
      });
      this.$set(heigthItem, "list", suitData);
    },
    // 单位切换
    handleSuitChange(item) {
      if (item.suitKey === "heightUnit") {
        let heightSuitItem = item.list.find(sItem => {
          return sItem.id === item.suitVal;
        });
        this.unit.heightUnitName = heightSuitItem.name;
        this.unit.heightUnit = heightSuitItem.id;
        // 厘米切换英寸 除以2.54
        // if (item.suitVal === 10265) {
        //   if (item.inputValue) {
        //     this.$set(
        //       item,
        //       "inputValue",
        //       (item.inputValue / SUITNUM).toFixed(2)
        //     );
        //   }
        // } else if (item.suitVal === 10266) {
        //   if (item.inputValue) {
        //     this.$set(
        //       item,
        //       "inputValue",
        //       (item.inputValue * SUITNUM).toFixed(2)
        //     );
        //   }
        // }
        this.handleConversion(this.unit.heightUnit);
      }
      if (item.suitKey === "genderId") {
        let genderItem = item.list.find(gItem => {
          return gItem.id === item.suitVal;
        });
        this.$set(item, "inputValue", genderItem.name);
      }
    },
    // 远程搜索客户
    async handRemoteCust(query) {
      if (!query) return false;
      let custNameItem = this.basicList.find(item => {
        return item.key === "customerName";
      });
      if (query) {
        this.$set(custNameItem, "loading", true);
        try {
          let response = await getCust({
            keywords: query
          });
          let {data, code} = response;
          this.$set(custNameItem, "list", data.data);
          this.$set(custNameItem, "loading", false);
        } catch (error) {
          this.$set(custNameItem, "loading", false);
        }
      }
    },
    // 选择客户
    async handleNameChange(custItem) {
      Object.keys(custItem).map(key => {
        this.basicList.map(item => {
          if (item.key === "customerName") {
            this.$set(item, "inputValue", custItem.id);
            this.basicCustomer = custItem.id;
            return false;
          }
          if (item.key === key) {
            this.$set(item, "inputValue", custItem[key]);
            if (!item.suitKey) return false;
            this.$set(item, "suitVal", custItem[item.suitKey]);
          }
        });
      });
      this.customer.customerId = custItem.id;
      if (this.submitData.sizeCategoryId === 10053) {
        this.sizeList.map(sItem => {
          if (custItem.cySizeList && custItem.cySizeList.length > 0) {
            let cySizeList = custItem.cySizeList.find(cyItem => {
              return cyItem.clothId === sItem.id;
            });
            if (cySizeList) {
              sItem.sizeList.map(sizeItem => {
                this.$set(sizeItem, "inputValue", "");
                cySizeList.partList.map(cyItem => {
                  if (cyItem.partId === sizeItem.id) {
                    this.$set(sizeItem, "inputValue", cyItem.partSize);
                  }
                });
              });
            } else {
              sItem.sizeList.map(sizeItem => {
                this.$set(sizeItem, "inputValue", "");
              });
            }
          } else {
            sItem.sizeList.map(sizeItem => {
              this.$set(sizeItem, "inputValue", "");
            });
          }
        });
      } else {
        // 客户尺码赋值
        if (custItem.customerSizeList.length === 0) {
          this.sizeList.map(sItem => {
            if (this.submitData.sizeCategoryId !== 10054) {
              sItem.sizeList.map(sizeItem => {
                this.$set(sizeItem, "inputValue", "");
              });
            } else {
              sItem.details.map(dItem => {
                this.$set(dItem, "inputValue", cItem.partSize);
              });
            }
          });
        } else {
          this.sizeList.map(sItem => {
            // 净体成衣
            if (this.submitData.sizeCategoryId !== 10054) {
              sItem.sizeList.map(sizeItem => {
                this.$set(sizeItem, "inputValue", "");
                custItem.customerSizeList.map(cItem => {
                  if (cItem.partId === sizeItem.id) {
                    this.$set(sizeItem, "inputValue", cItem.partSize);
                  }
                });
              });
              // 标准号
            } else {
              sItem.details.map(dItem => {
                custItem.customerSizeList.map(cItem => {
                  if (cItem.partId === dItem.id) {
                    this.$set(dItem, "inputValue", cItem.partSize);
                  }
                });
              });
            }
          });
        }
      }
      if (this.unit.heightUnit !== custItem.heightUnit) {
        this.$set(this.unit, "heightUnitName", custItem.heightUnitName);
        this.$set(this.unit, "heightUnit", custItem.heightUnit);

        this.handleConversion(custItem.heightUnit, true);
      }
      this.getSpecBody();
    },
    // 获取量体方式
    async handleVolumeList(volumeData) {
      this.volumeList = volumeData;
    },
    // 量体方式选择
    async handleTypeChange(val) {
      this.submitData.sizeCategoryId = val.value;
      this.getSpecBody();
      if (val.value === 10054) {
        this.getSizeType();
      }
      // this.getSize();
      this.handleHXSize();
    },
    handleSpecBody(specBodyData) {
      this.specBodyList = specBodyData;
      if (!this.specBodyList || this.specBodyList.length <= 0) return false
      this.specBodyList.map(item => {
        if (item.chooseId) return false;
        let normalItem = item.details.find((dItem, dIIndex) => dIIndex === 0);
        this.$set(item, "chooseId", normalItem.id);
      });
    },
    // 获取特体
    async getSpecBody() {
      try {
        let response = await specBody({
          category: this.routeParams.id,
          sizeType: this.submitData.sizeCategoryId,
          customerId: this.customer.customerId
        });
        let {data, code} = response;
        this.specBodyList = data.data;
        this.specBodyList.map(item => {
          if (item.chooseId) return false;
          let normalItem = item.details.find((dItem, dIIndex) => dIIndex === 0);
          this.$set(item, "chooseId", normalItem.id);
        });
      } catch (error) {
      }
    },
    // 获取号型大类
    async getSizeType() {
      try {
        let response = await standard({
          category: this.routeParams.id
        });
        let {data, code} = response;
        this.sizeTypeList = data.data;
        this.submitData.sizeAreaId = this.sizeTypeList[0].id;
        this.handleSizeType(this.submitData.sizeAreaId);
      } catch (error) {
      }
    },
    // 判断当前品类的工艺是否存在长短袖
    handleHasExtension() {
      this.categoryList.find(citem => {
        let extensionItem = citem.craftList.find(item => undefined !== item.extension && item.extension.includes('\|'));
        if (extensionItem) {
          this.handleReviseSzieList(extensionItem);
        }
      });
    },
    // 设置标准号尺码-有缓存时
    handleSetBZHDetails(currentSize, sizeList) {
      let details = null
      sizeList.map(sItem => {
        if (currentSize.shape === sItem.id) {
          currentSize.sizeList.map(csitem => {
            sItem.details.map(sditem => {
              if (sditem.id === csitem.partId) {
                sditem.defaultValue = csitem.partValue
              }
            })
          })
          details = sItem.details
        }
      })
      return details
    },
    handleSizeAction(sizeData) {
      this.sizeList = sizeData;
      // 净体成衣
      if (this.submitData.sizeCategoryId !== 10054) {
        this.sizeList.map(sizeItem => {
          this.dressStyleList.map(styleItem => {
            if (sizeItem.id === styleItem.id) {
              this.$set(sizeItem, "dressStyleList", styleItem.styleList);
            }
          });
        });
      }

      // 新增
      if (!this.routeParams.orderId) {
        //净体成衣
        if (this.submitData.sizeCategoryId !== 10054) {
          this.sizeList.map(sizeItem => {
            this.$set(sizeItem, "value", 10284);
            this.$set(sizeItem, "sizeVal", null);
            sizeItem.sizeList.map(sItem => {
              this.$set(sItem, "inputValue", sItem.defaultValue || null);
            });
          });
          // 标准号
        } else {
          this.sizeList.map(item => {
            if (item.sizeList.length <= 0) return false
            let currentSize = this.plData.detailList.find(ditem => {
              return ditem.clothCategory === item.id
            })
            let sizeVal = currentSize.shape || item.sizeList[0].id;
            this.$set(item, "sizeVal", sizeVal);
            console.log(this.handleSetBZHDetails(currentSize, item.sizeList))
            this.$set(item, "details", this.handleSetBZHDetails(currentSize, item.sizeList) || item.sizeList[0].details);

            item.sizeList.map(sItem => {
              sItem.details.map(dItem => {
                this.$set(dItem, "inputValue", dItem.defaultValue || null);
                this.$set(dItem, "addNum", 0.5);
              });
            });
          });
        }
        this.handleHasExtension();

      } else {
        if (this.submitData.sizeCategoryId === 10054) {
          this.sizeList.map(item => {
            if (item.sizeList.length <= 0) return false
            let sizeVal = item.sizeList[0].id;
            this.$set(item, "sizeVal", sizeVal);
            item.sizeList.map(sItem => {
              this.$set(item, "details", item.sizeList[0].details);
              sItem.details.map(dItem => {
                this.$set(dItem, "inputValue", dItem.defaultValue || null);
                this.$set(dItem, "addNum", 0.5);
              });
            });
          });
        } else {
          this.sizeList.map(sizeItem => {
            this.$set(sizeItem, "value", 10284);
            sizeItem.sizeList.map(item => {
              this.$set(item, "inputValue", item.defaultValue || null);
              this.$set(item, "addNum", 0.5);
            });
          });
        }
        this.handleHasExtension();
        // 如果编辑返回的数据是英寸(10265)，处理尺寸值
        if (this.unit.heightUnit === 10265) {
          this.sizeList.map(sItem => {
            if (sItem.details && sItem.details.legnth > 0) {
              sItem.details.map(dItem => {
                this.$set(
                  dItem,
                  "maxValue",
                  parseFloat((dItem.maxValue / SUITNUM).toFixed(2))
                );
                this.$set(
                  dItem,
                  "minValue",
                  parseFloat((dItem.minValue / SUITNUM).toFixed(2))
                );
              });
            }
            sItem.sizeList.map(sizeItem => {
              // 标准号
              if (this.submitData.sizeCategoryId === 10054) {
                sizeItem.details.map(dItem => {
                  if (!this.$route.query.orderId) {
                    this.$set(
                      dItem,
                      "inputValue",
                      parseFloat((dItem.inputValue / SUITNUM).toFixed(2))
                    );
                  }

                  this.$set(
                    dItem,
                    "maxValue",
                    parseFloat((dItem.maxValue / SUITNUM).toFixed(2))
                  );
                  this.$set(
                    dItem,
                    "minValue",
                    parseFloat((dItem.minValue / SUITNUM).toFixed(2))
                  );
                });
                // 净体成衣
              } else {
                if (!this.$route.query.orderId) {
                  this.$set(
                    sizeItem,
                    "inputValue",
                    parseFloat((sizeItem.inputValue / SUITNUM).toFixed(2))
                  );
                }

                this.$set(
                  sizeItem,
                  "maxValue",
                  parseFloat((sizeItem.maxValue / SUITNUM).toFixed(2))
                );
                this.$set(
                  sizeItem,
                  "minValue",
                  parseFloat((sizeItem.minValue / SUITNUM).toFixed(2))
                );
              }
            });
          });
        }
      }
    },
    // 获取尺码
    async getSize() {
      try {
        let response = await measureInfo({
          category: this.routeParams.id,
          measureType: this.submitData.sizeCategoryId,
          shapeCategory: this.submitData.sizeAreaId,
          customerId:
            this.submitData.sizeCategoryId === 10054
              ? null
              : this.customer.customerId
        });
        let {data, code} = response;
        this.sizeList = data.data;

        // 净体成衣
        if (this.submitData.sizeCategoryId !== 10054) {
          this.sizeList.map(sizeItem => {
            this.dressStyleList.map(styleItem => {
              if (sizeItem.id === styleItem.id) {
                this.$set(sizeItem, "dressStyleList", styleItem.styleList);
              }
            });
          });
        }

        // 新增
        if (!this.routeParams.orderId) {
          //净体成衣
          if (this.submitData.sizeCategoryId !== 10054) {
            this.sizeList.map(sizeItem => {
              this.$set(sizeItem, "value", 10284);
              this.$set(sizeItem, "sizeVal", null);
              sizeItem.sizeList.map(sItem => {
                this.$set(sItem, "inputValue", sItem.defaultValue || null);
              });
            });
          } else {
            this.sizeList.map(item => {
              let sizeVal = item.sizeList[0].id;
              this.$set(item, "sizeVal", sizeVal);
              item.sizeList.map(sItem => {
                this.$set(item, "details", item.sizeList[0].details);
                sItem.details.map(dItem => {
                  this.$set(dItem, "inputValue", dItem.defaultValue || null);
                  this.$set(dItem, "addNum", 0.5);
                });
              });
            });
          }
          this.handleHasExtension();
        } else {
          if (this.submitData.sizeCategoryId === 10054) {
            this.sizeList.map(item => {
              let sizeVal = item.sizeList[0].id;
              this.$set(item, "sizeVal", sizeVal);
              item.sizeList.map(sItem => {
                this.$set(item, "details", item.sizeList[0].details);
                sItem.details.map(dItem => {
                  this.$set(dItem, "inputValue", dItem.defaultValue || null);
                  this.$set(dItem, "addNum", 0.5);
                });
              });
            });
          } else {
            this.sizeList.map(sizeItem => {
              this.$set(sizeItem, "value", 10284);
              sizeItem.sizeList.map(item => {
                this.$set(item, "inputValue", item.defaultValue || null);
                this.$set(item, "addNum", 0.5);
              });
            });
          }
          this.handleHasExtension();
          // 如果编辑返回的数据是英寸(10265)，处理尺寸值
          if (this.unit.heightUnit === 10265) {
            this.sizeList.map(sItem => {
              if (sItem.details && sItem.details.legnth > 0) {
                sItem.details.map(dItem => {
                  this.$set(
                    dItem,
                    "maxValue",
                    parseFloat((dItem.maxValue / SUITNUM).toFixed(2))
                  );
                  this.$set(
                    dItem,
                    "minValue",
                    parseFloat((dItem.minValue / SUITNUM).toFixed(2))
                  );
                });
              }
              sItem.sizeList.map(sizeItem => {
                // 标准号
                if (this.submitData.sizeCategoryId === 10054) {
                  sizeItem.details.map(dItem => {
                    if (!this.$route.query.orderId) {
                      this.$set(
                        dItem,
                        "inputValue",
                        parseFloat((dItem.inputValue / SUITNUM).toFixed(2))
                      );
                    }

                    this.$set(
                      dItem,
                      "maxValue",
                      parseFloat((dItem.maxValue / SUITNUM).toFixed(2))
                    );
                    this.$set(
                      dItem,
                      "minValue",
                      parseFloat((dItem.minValue / SUITNUM).toFixed(2))
                    );
                  });
                  // 净体成衣
                } else {
                  if (!this.$route.query.orderId) {
                    this.$set(
                      sizeItem,
                      "inputValue",
                      parseFloat((sizeItem.inputValue / SUITNUM).toFixed(2))
                    );
                  }

                  this.$set(
                    sizeItem,
                    "maxValue",
                    parseFloat((sizeItem.maxValue / SUITNUM).toFixed(2))
                  );
                  this.$set(
                    sizeItem,
                    "minValue",
                    parseFloat((sizeItem.minValue / SUITNUM).toFixed(2))
                  );
                }
              });
            });
          }
        }

        // heightUnit && this.handleConversion(heightUnit);
      } catch (error) {
      }
    },
    // 尺码换算
    handleConversion(unit, type) {
      // 英寸换算厘米
      if (unit === 10266) {
        this.sizeList.map(sItem => {
          sItem.sizeList.map(sizeItem => {
            // 标准号
            if (this.submitData.sizeCategoryId === 10054) {
              sizeItem.details.map(dItem => {
                this.$set(
                  dItem,
                  "maxValue",
                  parseFloat((dItem.maxValue * SUITNUM).toFixed(2))
                );
                this.$set(
                  dItem,
                  "minValue",
                  parseFloat((dItem.minValue * SUITNUM).toFixed(2))
                );
                if (dItem.defaultValue === dItem.inputValue) return false;
                if (dItem.inputValue) {
                  this.$set(
                    dItem,
                    "inputValue",
                    parseFloat((dItem.inputValue * SUITNUM).toFixed(1))
                  );
                }
              });
              return false;
            }
            // 净体成衣
            this.$set(
              sizeItem,
              "maxValue",
              parseFloat((sizeItem.maxValue * SUITNUM).toFixed(2))
            );
            this.$set(
              sizeItem,
              "minValue",
              parseFloat((sizeItem.minValue * SUITNUM).toFixed(2))
            );

            if (!type && sizeItem.inputValue) {
              this.$set(
                sizeItem,
                "inputValue",
                parseFloat((sizeItem.inputValue * SUITNUM).toFixed(2))
              );
            }
          });
        });
        // 厘米换算成英寸
      } else if (unit === 10265) {
        this.sizeList.map(sItem => {
          sItem.sizeList.map(sizeItem => {
            // 标准号
            if (this.submitData.sizeCategoryId === 10054) {
              sizeItem.details.map(dItem => {
                this.$set(
                  dItem,
                  "maxValue",
                  parseFloat((dItem.maxValue / SUITNUM).toFixed(2))
                );
                this.$set(
                  dItem,
                  "minValue",
                  parseFloat((dItem.minValue / SUITNUM).toFixed(2))
                );

                if (dItem.inputValue) {
                  this.$set(
                    dItem,
                    "inputValue",
                    parseFloat((dItem.inputValue / SUITNUM).toFixed(1))
                  );
                }
              });
              return false;
            }
            // 净体成衣
            this.$set(
              sizeItem,
              "maxValue",
              parseFloat((sizeItem.maxValue / SUITNUM).toFixed(2))
            );
            this.$set(
              sizeItem,
              "minValue",
              parseFloat((sizeItem.minValue / SUITNUM).toFixed(2))
            );
            if (!type && sizeItem.inputValue) {
              this.$set(
                sizeItem,
                "inputValue",
                parseFloat((sizeItem.inputValue / SUITNUM).toFixed(2))
              );
            }
          });
        });
      }
    },
    // 获取着装风格
    async handleDressStyle(dressStyleData) {
      this.dressStyleList = dressStyleData;
    },
    handleStyleTypeAction(styleTypeData) {
      this.styleTypeList = styleTypeData;
    },
    // 获取长短款
    async getStyleType() {
      try {
        let response = await dictbasicList({
          category: 41
        });
        let {data, code} = response;
        this.styleTypeList = data.data;
      } catch (error) {
      }
    },
    // 选择特体
    handleSpecBodyChange(item, dItem) {
      this.$set(item, "chooseId", dItem.id);
      this.specBodyImg = dItem.imagePath;
      this.specBodyText = dItem.description;
    },
    // 号型大类选择
    handleSizeType(id) {
      this.editDetails = [];
      this.submitData.sizeAreaId = id;
      // this.getSize();
      this.handleHXSize();
    },
    // 此方法专门处理尺码换算
    handleSpeciallySizelse(unit, sizeItem) {
      if (!sizeItem) {
        if (unit === 10265) {
          // 厘米转英寸
          this.sizeList.map(item => {
            // 标准号
            if (this.submitData.sizeCategoryId === 10054) {
              item.sizeList.map(sitem => {
                sitem.details.map(ditem => {
                  this.$set(
                    ditem,
                    "inputValue",
                    ditem.inputValue
                      ? parseFloat(ditem.inputValue / SUITNUM).toFixed(2)
                      : null
                  );
                });
              });
            } else {
              item.sizeList.map(sitem => {
                this.$set(
                  sitem,
                  "inputValue",
                  sitem.inputValue
                    ? parseFloat(sitem.inputValue / SUITNUM).toFixed(2)
                    : ""
                );
              });
            }
          });
        } else if (unit === 10266) {
          // 英寸转厘米
          this.sizeList.map(item => {
            // 标准号
            if (this.submitData.sizeCategoryId === 10054) {
              item.sizeList.map(sitem => {
                sitem.details.map(ditem => {
                  this.$set(
                    ditem,
                    "inputValue",
                    ditem.inputValue
                      ? parseFloat(ditem.inputValue * SUITNUM).toFixed(2)
                      : ""
                  );
                });
              });
            } else {
              item.sizeList.map(sitem => {
                this.$set(
                  sitem,
                  "inputValue",
                  sitem.inputValue
                    ? parseFloat(sitem.inputValue * SUITNUM).toFixed(2)
                    : ""
                );
              });
            }
          });
        }
      } else {
        if (unit === 10265) {
          // 厘米转英寸
          // 标准号
          if (this.submitData.sizeCategoryId === 10054) {
            sizeItem.sizeList.map(sitem => {
              sitem.details.map(ditem => {
                this.$set(
                  ditem,
                  "inputValue",
                  ditem.inputValue
                    ? parseFloat(ditem.inputValue / SUITNUM).toFixed(2)
                    : null
                );
              });
            });
          } else {
            sizeItem.sizeList.map(sitem => {
              this.$set(
                sitem,
                "inputValue",
                sitem.inputValue
                  ? parseFloat(sitem.inputValue / SUITNUM).toFixed(2)
                  : ""
              );
            });
          }
        } else if (unit === 10266) {
          // 英寸转厘米

          // 标准号
          if (this.submitData.sizeCategoryId === 10054) {
            sizeItem.sizeList.map(sitem => {
              sitem.details.map(ditem => {
                this.$set(
                  ditem,
                  "inputValue",
                  ditem.inputValue
                    ? parseFloat(ditem.inputValue * SUITNUM).toFixed(2)
                    : ""
                );
              });
            });
          } else {
            sizeItem.sizeList.map(sitem => {
              this.$set(
                sitem,
                "inputValue",
                sitem.inputValue
                  ? parseFloat(sitem.inputValue * SUITNUM).toFixed(2)
                  : ""
              );
            });
          }
        }
      }
    },
    // 切换号型大类尺码修改
    async handleHXSize() {
      try {
        let response = await measureInfo({
          category: this.routeParams.id,
          measureType: this.submitData.sizeCategoryId,
          shapeCategory: this.submitData.sizeAreaId,
          customerId:
            this.submitData.sizeCategoryId === 10054
              ? null
              : this.customer.customerId
        });
        let {data, code} = response;
        this.sizeList = data.data;

        // 净体成衣
        if (this.submitData.sizeCategoryId !== 10054) {
          this.sizeList.map(sizeItem => {
            this.dressStyleList.map(styleItem => {
              if (sizeItem.id === styleItem.id) {
                this.$set(sizeItem, "dressStyleList", styleItem.styleList);
              }
            });
          });
        }
        // 根据返回的尺码处理当前的尺码
        if (this.submitData.sizeCategoryId !== 10054) {
          this.sizeList.map(sizeItem => {
            this.$set(sizeItem, "value", 10284);
            this.$set(sizeItem, "sizeVal", null);
            if (
              sizeItem.details &&
              sizeItem.details.legnth > 0 &&
              this.unit.heightUnit === 10265
            ) {
              sizeItem.details.map(dItem => {
                this.$set(
                  dItem,
                  "maxValue",
                  parseFloat((dItem.maxValue / SUITNUM).toFixed(2))
                );
                this.$set(
                  dItem,
                  "minValue",
                  parseFloat((dItem.minValue / SUITNUM).toFixed(2))
                );
              });
            }
            sizeItem.sizeList.map(sItem => {
              this.$set(sItem, "inputValue", sItem.defaultValue || null);
              if (this.unit.heightUnit === 10265) {
                this.$set(
                  sItem,
                  "maxValue",
                  parseFloat((sItem.maxValue / SUITNUM).toFixed(2))
                );
                this.$set(
                  sItem,
                  "minValue",
                  parseFloat((sItem.minValue / SUITNUM).toFixed(2))
                );
              }
            });
          });
        } else {
          this.sizeList.map(item => {
            if (!item.sizeList || item.sizeList.length <= 0) return false;
            let sizeVal = item.sizeList[0].id;
            this.$set(item, "sizeVal", sizeVal);
            item.sizeList.map(sItem => {
              this.$set(item, "details", item.sizeList[0].details);
              sItem.details.map(dItem => {
                this.$set(dItem, "inputValue", dItem.defaultValue || null);
                this.$set(dItem, "addNum", 0.5);
                if (this.unit.heightUnit === 10265) {
                  this.$set(
                    dItem,
                    "maxValue",
                    parseFloat((dItem.maxValue / SUITNUM).toFixed(2))
                  );
                  this.$set(
                    dItem,
                    "minValue",
                    parseFloat((dItem.minValue / SUITNUM).toFixed(2))
                  );
                }
              });
            });
          });
        }
        this.handleHasExtension();
        // 首先判断是否选择了客户
        if (this.submitData.sizeCategoryId !== 10054) {
          // 量体方式为净体成衣
          // 判断当前的单位是否和客户的单位相同
          this.sizeList.map(item => {
            if (item.sizeUnit !== this.unit.heightUnit) {
              // 当前是英寸 => 厘米转英寸
              if (this.unit.heightUnit === 10265) {
                this.handleSpeciallySizelse(10265, item);
                // 当前是厘米 => 英寸转厘米
              } else if (this.unit.heightUnit === 10266) {
                this.handleSpeciallySizelse(10266, item);
              }
            }
          });
        } else {
          // 默认返回的厘米的尺码
          // 如果当前页面单位是英寸 => 厘米转英寸
          if (this.unit.heightUnit === 10265) {
            this.handleSpeciallySizelse(10265);
          }
        }
      } catch (error) {
      }
    },
    // 标准号尺码选择
    handleSizeChoose(item, sItem) {
      this.$set(item, "sizeVal", sItem.id);
      this.$set(item, "details", sItem.details);
      this.handleHasExtension();
    },
    // 处理刺绣提交数据
    handleSubmitEmbs() {
      this.categoryList.map(item => {
        this.detailList.map(dItem => {
          if (item.id === dItem.clothCategory) {
            if (!item.embList || item.embList.length <= 0) {
              return false;
            }
            dItem.embList = [];
            item.embList.map(emb_item => {
              emb_item.site && dItem.embList.push(emb_item);
            });
            dItem.embList.length &&
            dItem.embList.map(de_item => {
              if (this.$route.query.orderId) {
                if (de_item.file) {
                  this.$set(de_item, "sourceType", "edit");
                }
              } else {
                if (de_item.file) {
                  this.$set(de_item, "sourceType", "add");
                }
              }
            });
          }
        });
      });
    },
    // 处理撞色提交数据
    handleSubmitContrast() {
      this.categoryList.map(item => {
        this.detailList.map(dItem => {
          if (item.id === dItem.clothCategory) {
            if (!item.contrastSaveList || item.contrastSaveList.length <= 0) {
              return false;
            }
            dItem.contrastSaveList = [];
            item.contrastSaveList.map(contrast_item => {
              contrast_item.site && dItem.contrastSaveList.push(contrast_item);
            });
          }
        });
      });
    },
    // 处理尺码提交数据
    handleSubmitSize() {
      this.sizeList.map(item => {
        this.detailList.map(dItem => {
          if (item.id === dItem.clothCategory) {
            if (!item.sizeList || item.sizeList.length <= 0) {
              return false;
            }
            dItem.sizeList = [];
            if (this.submitData.sizeCategoryId !== 10054) {
              this.$set(dItem, "styleId", item.value);
            } else {
              this.$set(dItem, "shape", item.sizeVal);
            }
            if (this.submitData.sizeCategoryId !== 10054) {
              item.sizeList.map(sItem => {
                if (sItem.disabled) return false;

                dItem.sizeList.push({
                  partId: sItem.id,
                  partValue: sItem.inputValue || ""
                });
              });
            } else {
              item.details.map(sItem => {
                if (sItem.disabled) return false;

                dItem.sizeList.push({
                  partId: sItem.id,
                  partValue: sItem.inputValue || "",
                  modifyValue: sItem.inputValue - sItem.defaultValue || ""
                });
              });
            }
          }
        });
      });
    },
    // 处理客户信息提交数据
    handleSubmitCustomer() {
      Object.keys(this.customer).map(key => {
        if (key === "customerId") return false;
        this.basicList.map(item => {
          if (item.key === key) {
            if (key === "customerName") {
              this.customer[key] = item.customerName;
              return false;
            }
            this.customer[key] = item.inputValue;
          }
          if (item.suitKey && item.suitKey === key) {
            this.customer[key] = item.suitVal;
          }
        });
      });
      //处理订单备注
      this.submitData.memo = this.basicList[9].inputValue;
    },
    // 处理工艺提交数据
    handleSubmitCraft() {
      this.categoryList.map(item => {
        if (!item.craftList || item.craftList.length <= 0) {
          return false;
        }
        this.detailList.map(dItem => {
          if (item.id === dItem.clothCategory) {
            if (!item.craftList || item.craftList.length <= 0) {
              return false;
            }
            dItem.craftList = [];
            item.craftList.map(cItem => {
              dItem.craftList.push({
                craftId: cItem.craftId,
                content: cItem.content,
                file: cItem.file,
                sourceType:
                  cItem.file && this.$route.query.orderId
                    ? "edit"
                    : cItem.file
                      ? "add"
                      : ""
              });
            });
          }
        });
      });
    },
    // 处理特体提交
    handleSubmitSpecBody() {
      if (this.submitData.sizeCategoryId === 10054) {
        return false;
      }
      this.submitData.bodyTypeList = [];
      this.specBodyList.map(item => {
        if (item.chooseId) {
          this.submitData.bodyTypeList.push(item.chooseId);
        }
      });
    },
    // 校验工艺
    handleValidateCraft() {
      let hasCraft = true;
      let cItem = this.categoryList.find(item => {
        return item.craftList.length > 0;
      });
      if (!cItem) {
        hasCraft = false;
        this.$Message.error(`${this.$t("peofessional.craft")}`);
      } else {
        cItem.craftList.map(cItem => {
          if (!hasCraft) return false;
          if (cItem.sourceType === "TEXT") {
            if (!cItem.content) {
              hasCraft = false;
              this.$Message.error(`${this.$t("peofessional.craft2")}`);
            }
          } else if (cItem.sourceType === "FILE") {
            if (!cItem.file) {
              hasCraft = false;
              this.$Message.error(`${this.$t("peofessional.craft3")}`);
            }
          }
        });
      }
      return hasCraft;
    },
    handleValidateEmbs() {
      let isComplete = true;
      this.categoryList.map(item => {
        if (!isComplete) {
          return false;
        }
        item.embList.map(emb_item => {
          if (!emb_item.site && !emb_item.color && !emb_item.font) {
            return false;
          }
          if (!isComplete) {
            return false;
          }
          if (!emb_item.site) {
            this.$Message.error(`${item.name}${this.$t("peofessional.emb_1")}`);
            isComplete = false;
            return false;
          }
          if (!emb_item.color) {
            this.$Message.error(`${item.name}${this.$t("peofessional.emb_2")}`);
            isComplete = false;
            return false;
          }
          if (!emb_item.font) {
            this.$Message.error(`${item.name}${this.$t("peofessional.emb_3")}`);
            isComplete = false;
            return false;
          }
          if (emb_item.font === 1500) {
            if (!emb_item.file) {
              this.$Message.error(
                `${item.name}${this.$t("peofessional.emb_5")}`
              );
              isComplete = false;
              return false;
            }
          } else {
            if (!emb_item.embContent) {
              this.$Message.error(
                `${item.name}${this.$t("peofessional.emb_4")}`
              );
              isComplete = false;
              return false;
            }
          }
        });
      });
      return isComplete;
    },
    // 删除长短袖
    handleClearCraft() {
      if (this.submitData.sizeCategoryId === 10054) {
        this.sizeList.map(item => {
          // let currentSize = item.sizeList.find(sItem => {
          //   return sItem.id === item.sizeVal;
          // });
          // currentSize.details.map(dItem => {
          //   this.$set(dItem, "disabled", false);
          // });

          item.sizeList.find(sItem => {
            sItem.details.map(dItem => {
              this.$set(dItem, "disabled", false);
            });
          });
        });
      } else {
        this.sizeList.map(item => {
          item.sizeList.map(sItem => {
            this.$set(sItem, "disabled", false);
          });
        });
      }
    },
    // 长短袖
    handleReviseSzieList(craftData) {

      let showSize = null;
      let hideSize = null;
      let categoryCode = craftData.code.split("_")[0];
      if (!craftData.extension) {
        return false;
      }
      let sizes = craftData.extension.split("|");
      // 净体
      if (this.submitData.sizeCategoryId === 10052) {
        showSize = sizes[0].split("&")[0] || "";
        hideSize = sizes[0].split("&")[1] || "";
        // 成衣
      } else if (this.submitData.sizeCategoryId !== 10052) {
        showSize = sizes[1].split("&")[0];
        hideSize = sizes[1].split("&")[1];
      }

      if (this.submitData.sizeCategoryId !== 10054) {
        let currentItem = this.sizeList.find(item => {
          return item.id === Number(categoryCode);
        });
        currentItem.sizeList.map(item => {
          let hasSize = hideSize.includes(item.id);
          if (hasSize) {
            this.$set(item, "disabled", true);
          }
        });
      } else {
        let currentSize = this.sizeList.find(item => {
          return item.id === Number(categoryCode);
        });
        // let currentItem = currentSize.sizeList.find(item => {
        //   return item.id === currentSize.sizeVal;
        // });
        // currentItem.details.map(item => {
        //   let hasSize = hideSize.includes(item.id);
        //   if (hasSize) {
        //     this.$set(item, "disabled", true);
        //   }
        // });
        currentSize.sizeList.find(item => {
          item.details.map(ditem => {
            let hasSize = hideSize.includes(ditem.id);
            if (hasSize) {
              this.$set(ditem, "disabled", true);
            }
          });
        });
      }
    },
    // 校验客户信息
    handleValidateCustomner() {
      let isComplete = true;
      this.basicList.map(item => {
        if (!isComplete) return false;
        if (item.must && !item.inputValue) {
          if (item.customerName) return false;
          this.$Message.error(`请填写${item.label}`);
          isComplete = false;
        }
      });
      return isComplete;
    },
    // 校验尺码
    handleValidateSize() {
      let isComplte = true;
      this.sizeList.map(item => {
        if (!isComplte) return false;
        // 净体成衣
        if (this.submitData.sizeCategoryId !== 10054) {
          item.sizeList.map(sItem => {
            if (sItem.disabled) return false;
            if (!isComplte) return false;
            if (sItem.isMust) {
              if (!sItem.inputValue) {
                this.$Message.error(
                  `${this.$t("peofessional.sizetip1")} ${sItem.name} ${this.$t(
                    "peofessional.sizetip2"
                  )}`
                );
                isComplte = false;
              } else {
                if (
                  sItem.inputValue < sItem.minValue ||
                  sItem.inputValue > sItem.maxValue
                ) {
                  this.$Message.error(
                    `${sItem.name} ${this.$t("peofessional.range")}`
                  );
                  isComplte = false;
                }
              }
            } else {
              if (sItem.inputValue) {
                if (
                  sItem.inputValue < sItem.minValue ||
                  sItem.inputValue > sItem.maxValue
                ) {
                  this.$Message.error(
                    `${sItem.name} ${this.$t("peofessional.range")}`
                  );
                  isComplte = false;
                }
              }
            }
          });
          // 标准号
        } else {
          item.sizeList.map(sItem => {
            if (sItem.id !== item.sizeVal) return false;
            if (!isComplte) return false;
            sItem.details.map(dItem => {
              if (!isComplte) return false;
              if (dItem.isMust) {
                if (!dItem.inputValue) {
                  this.$Message.error(
                    `${this.$t("peofessional.sizetip1")} ${dItem.name
                    } ${this.$t("peofessional.sizetip2")}`
                  );
                  isComplte = false;
                } else {
                  if (
                    dItem.inputValue < dItem.minValue ||
                    dItem.inputValue > dItem.maxValue
                  ) {
                    this.$Message.error(
                      `${dItem.name} ${this.$t("peofessional.range")}`
                    );
                    isComplte = false;
                  }
                }
              } else {
                if (dItem.inputValue) {
                  if (
                    dItem.inputValue < dItem.minValue ||
                    dItem.inputValue > dItem.maxValue
                  ) {
                    this.$Message.error(
                      `${dItem.name} ${this.$t("peofessional.range")}`
                    );
                    isComplte = false;
                  }
                }
              }
            });
          });
        }
      });
      return isComplte;
    },
    // 提交校验
    handleValidateSubmit() {
      if (!this.submitData.fabric) {
        this.$Message.error(`${this.$t("peofessional.fabric")}`);
        return false;
      }

      if (!this.handleValidateCraft()) {
        return false;
      }
      if (!this.handleValidateEmbs()) {
        return false;
      }
      if (!this.handleValidateCustomner()) {
        return false;
      }
      if (!this.handleValidateSize()) {
        return false;
      }
      return true;
    },
    // 提交处理数据
    handleSubmitData(type) {
      if (!this.handleValidateSubmit()) return false;
      this.handleSubmitCraft();
      this.handleSubmitEmbs();
      this.handleSubmitContrast();
      this.handleSubmitCustomer();
      this.handleSubmitSize();
      this.handleSubmitSpecBody();
      this.submitData.detailList = this.detailList;
      this.submitData = Object.assign(this.submitData, this.customer);
      this.spinShow = true;
      if (type === "cart") {
        this.handleSubmitCart();
      } else if (type === "order") {
        this.handleSubmitOrder();
      }
      sessionStorage.removeItem("plData");
    },
    // 提交加入购物车
    async handleSubmitCart() {
      try {
        let response = await submitCart(this.submitData);
        let {data} = response;
        if (data.code === 0) {
          this.$Message.success(data.message);
          if (
            this.routeParams.orderType &&
            this.routeParams.orderType === "pending"
          ) {
            this.$router.push("/myOrder");
          } else {
            this.$router.push("/saveItems");
          }
          this.spinShow = false;
        }
      } catch (error) {
        this.spinShow = false;
      }
    },
    // 获取接口返回数据中有用的部分
    handleGetReturnDatat(data) {
      let returnData = {};
      Object.keys(data).map(key => {
        Object.keys(data[key]).map(data_key => {
          returnData = data[key][data_key];
        });
      });
      return returnData;
    },
    // 提交到订单
    async handleSubmitOrder() {
      try {
        let {status, data} = await submitOrder(this.submitData);
        if (data.code === 0) {
          let returnData = this.handleGetReturnDatat(data);
          this.spinShow = false;
          if (returnData.sign && returnData.sign === "fail") {
            this.$Message.info("Failed");
            this.$router.push("/myOrder");
          } else {
            this.$Message.success(data.message);
            this.$router.push("/underProduction");
          }
        } else {
          this.$Message.error(data.message);
          this.spinShow = false;
        }
      } catch (error) {
        this.spinShow = false;
      }
    },
    async getData() {
      this.plData = JSON.parse(sessionStorage.getItem("plData")) || {detailList: []};
      if (this.plData.sizeCategoryId) {
        this.submitData.sizeCategoryId = this.plData.sizeCategoryId
      }
      // 获取品类
      this.submitData.clothCategory = this.routeParams.id;
      if (!this.routeParams.orderId) {
        let {data} = await getUserCategory({cloth: this.routeParams.id});
        if (data.data && data.data.length > 0) {
          this.userCraftList = data.data;
        }
      }
      /**
       * @method 品类详细信息
       * @method 性别
       * @method 身高
       * @method 体重
       * @method 量体方式
       * @method 特体
       */
      let [
        {
          data: {data: categoryData}
        },
        {
          data: {data: sexData}
        },
        {
          data: {data: heightData}
        },
        {
          data: {data: weightData}
        },
        {
          data: {data: volumeData}
        },
        {
          data: {data: dressStyleData}
        },
        {
          data: {data: specBodyData}
        }
      ] = await Promise.all([
        getCategoryInfo({category: this.routeParams.id}),
        listDictSystem({category: 10}),
        listDictSystem({category: 29}),
        listDictSystem({category: 30}),
        listDictSystem({category: 13}),
        styleInfo({category: this.routeParams.id}),
        specBody({
          category: this.routeParams.id,
          sizeType: this.submitData.sizeCategoryId,
          customerId: this.customer.customerId
        })
      ]);
      this.handleCategoryData(categoryData);
      this.handleCustomerBaseInfo(10, sexData);
      this.handleCustomerBaseInfo(29, heightData);
      this.handleCustomerBaseInfo(30, weightData);
      this.handleVolumeList(volumeData);
      this.handleDressStyle(dressStyleData);
      this.handleSpecBody(specBodyData);
      if (this.submitData.sizeCategoryId === 10054) {
        let response = await standard({
          category: this.routeParams.id
        });
        let {data} = response;
        this.sizeTypeList = data.data;
        this.submitData.sizeAreaId = this.plData.sizeAreaId || this.sizeTypeList[0].id;
        this.plData.sizeAreaId || this.handleSizeType(this.submitData.sizeAreaId);
      }
      if (!this.routeParams.orderId) {
        // 获取尺码
        // if (this.lang !== "zh") {
        //   this.getSize(this.unit.heightUnit);
        // } else {
        //   this.getSize();
        // }
        // this.getSize();
        // this.getStyleType()
        let [
          {
            data: {data: sizeData}
          },
          {data: {data: styleTypeData}}
        ] = await Promise.all([
          measureInfo({
            category: this.routeParams.id,
            measureType: this.submitData.sizeCategoryId,
            shapeCategory: this.plData.sizeAreaId || this.submitData.sizeAreaId,
            customerId:
              this.submitData.sizeCategoryId === 10054
                ? null
                : this.customer.customerId
          }),
          dictbasicList({
            category: 41
          })
        ]);
        this.handleSizeAction(sizeData);
        this.handleStyleTypeAction(styleTypeData);
      }
      if (this.plData.detailList.length > 0) {
        this.unit.heightUnit = this.plData.heightUnit
        if (this.unit.heightUnit === 10265) {
          this.sizeList.map(sItem => {
            if (sItem.details && sItem.details.legnth > 0) {
              sItem.details.map(dItem => {
                this.$set(
                  dItem,
                  "maxValue",
                  parseFloat((dItem.maxValue / SUITNUM).toFixed(2))
                );
                this.$set(
                  dItem,
                  "minValue",
                  parseFloat((dItem.minValue / SUITNUM).toFixed(2))
                );
              });
            }
            sItem.sizeList.map(sizeItem => {
              // 标准号
              if (this.submitData.sizeCategoryId === 10054) {
                sizeItem.details.map(dItem => {
                  this.$set(
                    dItem,
                    "maxValue",
                    parseFloat((dItem.maxValue / SUITNUM).toFixed(2))
                  );
                  this.$set(
                    dItem,
                    "minValue",
                    parseFloat((dItem.minValue / SUITNUM).toFixed(2))
                  );
                  this.$set(
                    dItem,
                    "inputValue",
                    parseFloat((dItem.inputValue / SUITNUM).toFixed(2))
                  );
                });
                // 净体成衣
              } else {
                this.$set(
                  sizeItem,
                  "maxValue",
                  parseFloat((sizeItem.maxValue / SUITNUM).toFixed(2))
                );
                this.$set(
                  sizeItem,
                  "minValue",
                  parseFloat((sizeItem.minValue / SUITNUM).toFixed(2))
                );
              }
            });
          });
        }
        this.handleEditData(this.plData);
        this.customer.customerId = this.plData.customerId
        this.timestamp = Date.now()
        return false;
      }
      if (this.routeParams.orderId) {
        this.getEditData();
      }
      /*
      // 获取品类详细信息
      this.getCatgoryData();
      // 获取性别
      this.getCustomerBaseInfo(10);
      // 获取身高
      this.getCustomerBaseInfo(29);
      // 获取体重
      this.getCustomerBaseInfo(30);
      // 获取量体方式
      this.getvolumeList();
      // 获取着装风格
      this.getDressStyle();
      // 获取长短款
      // this.handleTypeChange();
      this.getSpecBody();
      */
    },
    // 获取编辑数据
    async getEditData() {
      try {
        let response = await editOrder({
          orderId: this.routeParams.orderId,
          type:
            this.routeParams.orderType &&
            this.routeParams.orderType === "buyagain"
              ? "buy"
              : "edit"
        });
        let {data, code} = response;
        // 失焦不显示面料问题
        this.$refs.rPeofessional[0].setSelectFabric(data.data.fabric)
        //订单数量
        this.submitData.amount = data.data.amount;
        this.submitData.addProduct = data.data.addProduct;
        this.params.productId = data.data.fabricType;
        this.editDetails = data.data.detailList;
        this.orderCode = data.data.orderCode;
        this.blError = data.data.blError;
        if (this.submitData.sizeCategoryId === 10054) {
          this.submitData.sizeAreaId = data.data.sizeAreaId;
        }
        this.customer.customerId = data.data.customerId;
        this.unit.heightUnit = data.data.heightUnit;
        this.unit.heightUnitName = data.data.heightUnitName;
        this.getStyleType();

        let response2 = await measureInfo({
          category: this.routeParams.id,
          measureType: this.submitData.sizeCategoryId,
          shapeCategory: this.submitData.sizeAreaId,
          customerId:
            this.submitData.sizeCategoryId === 10054
              ? null
              : this.customer.customerId
        });

        this.sizeList = response2.data.data;

        this.editDetails.map(item => {
          let currentSizeItem = this.sizeList.find(sitem => {
            return sitem.id === item.clothCategory;
          });
          currentSizeItem.sizeList.map(Sitem => {
            this.$set(Sitem, "disabled", true);
          });
          if (this.submitData.sizeCategoryId !== 10054) {
            item.sizeList.map(Item => {
              let currentItem = currentSizeItem.sizeList.find(sitem => {
                return Item.partId === sitem.id;
              });
              if (undefined !== currentItem) {
                this.$set(currentItem, "disabled", false);
              }
            });
          }
        });
        // 净体成衣
        if (this.submitData.sizeCategoryId !== 10054) {
          this.sizeList.map(sizeItem => {
            this.dressStyleList.map(styleItem => {
              if (sizeItem.id === styleItem.id) {
                this.$set(sizeItem, "dressStyleList", styleItem.styleList);
              }
            });
          });
        }
        if (this.submitData.sizeCategoryId === 10054) {
          this.sizeList.map(item => {
            let sizeVal = item.sizeList[0].id;
            this.$set(item, "sizeVal", sizeVal);
            item.sizeList.map(sItem => {
              this.$set(item, "details", item.sizeList[0].details);
              sItem.details.map(dItem => {
                this.$set(dItem, "inputValue", dItem.defaultValue || null);
                this.$set(dItem, "addNum", 0.5);
              });
            });
          });
        }
        if (this.unit.heightUnit === 10265) {
          this.sizeList.map(sItem => {
            if (sItem.details && sItem.details.legnth > 0) {
              sItem.details.map(dItem => {
                this.$set(
                  dItem,
                  "maxValue",
                  parseFloat((dItem.maxValue / SUITNUM).toFixed(2))
                );
                this.$set(
                  dItem,
                  "minValue",
                  parseFloat((dItem.minValue / SUITNUM).toFixed(2))
                );
              });
            }
            sItem.sizeList.map(sizeItem => {
              // 标准号
              if (this.submitData.sizeCategoryId === 10054) {
                sizeItem.details.map(dItem => {
                  this.$set(
                    dItem,
                    "maxValue",
                    parseFloat((dItem.maxValue / SUITNUM).toFixed(2))
                  );
                  this.$set(
                    dItem,
                    "minValue",
                    parseFloat((dItem.minValue / SUITNUM).toFixed(2))
                  );
                  this.$set(
                    dItem,
                    "inputValue",
                    parseFloat((dItem.inputValue / SUITNUM).toFixed(2))
                  );
                });
                // 净体成衣
              } else {
                this.$set(
                  sizeItem,
                  "maxValue",
                  parseFloat((sizeItem.maxValue / SUITNUM).toFixed(2))
                );
                this.$set(
                  sizeItem,
                  "minValue",
                  parseFloat((sizeItem.minValue / SUITNUM).toFixed(2))
                );
              }
            });
          });
        }
        this.handleEditData(data.data);
      } catch (error) {
      }
    },
    // 处理编辑数据
    handleEditData(editData) {
      this.submitData.cusOrderCode = editData.cusOrderCode || "";
      this.submitData.sizeCategoryId = editData.sizeCategoryId
      // 面料号
      this.submitData.fabric = editData.fabric;
      if (this.submitData.sizeCategoryId !== 10054 && editData.style !== '') {
        this.submitData.style = Number(editData.style);
      }
      //处理订单备注
      this.$set(this.basicList[9], "inputValue", editData.memo);

      this.$set(this.unit, "heightUnitName", editData.heightUnitName);

      // 处理编辑工艺信息
      this.handleEditCraftData(editData.detailList);
      // 处理编辑客户信息
      this.handleEditCustomer(editData);

      // 处理编辑刺绣信息
      this.handleEditEmbData(editData.detailList);
      // 处理编辑撞色信息
      this.handleEditContrastData(editData.detailList);
      // 处理编辑特体信息
      if (
        this.submitData.sizeCategoryId !== 10054 &&
        editData.bodyTypeList.length > 0
      ) {
        this.handleEditSpecBody(editData.bodyTypeList);
      }
      // 处理编辑尺码信息
      this.handleEditSizeData(editData.detailList);
      this.handleHasExtension();
    },
    // 编辑客户信息
    handleEditCustomer(editData) {
      Object.keys(this.customer).map(key => {
        if (key === "customerId") {
          this.submitData.customerId = editData.customerId;
          return false;
        }
        this.basicList.map(basicItem => {
          if (basicItem.key === key) {
            if (key === "customerName") {
              this.$set(basicItem, "customerName", editData.customerName);
            }
            this.$set(basicItem, "inputValue", editData[key]);
          }
          if (basicItem.suitKey && basicItem.suitKey === key) {
            this.$set(basicItem, "suitVal", editData[key]);
          }
        });
      });
    },
    // 编辑特体数据
    handleEditSpecBody(bodyTypeList) {
      this.specBodyList.map(item => {
        bodyTypeList.map(specId => {
          let fitIndex = item.details.findIndex(dItem => {
            return dItem.id === Number(specId);
          });
          if (fitIndex >= 0) {
            this.$set(item, "chooseId", specId);
          }
        });
      });
    },
    // 编辑工艺数据
    handleEditCraftData(detailList) {
      this.categoryList.map(cItem => {
        detailList.map(dItem => {
          if (cItem.id === dItem.clothCategory) {
            this.$set(cItem, "craftList", dItem.craftList);
          }
        });
      });
    },
    // 编辑刺绣数据
    handleEditEmbData(detailList) {
      this.categoryList.map(cItem => {
        cItem.embList = [];
        let fixItem = detailList.find(dItem => {
          return cItem.id === dItem.clothCategory;
        });
        if (fixItem && fixItem.embList && fixItem.embList.length > 0) {
          cItem.embList = [];
        } else {
          cItem.embList.push({
            site: null, // 位置
            color: null, // 颜色
            font: null, // 字体
            file: null,
            fileName: "",
            href: "",
            uploadContent: false,
            embSize: null, // 绣字大小
            embContent: "" // 内容
          });
          return false;
        }
        fixItem.embList.map(embItem => {
          this.$set(this.embItem, "site", embItem.site || "");
          this.$set(this.embItem, "color", embItem.color || "");
          this.$set(this.embItem, "font", embItem.font || "");
          this.$set(this.embItem, "file", embItem.file || "");
          this.$set(this.embItem, "fileName", embItem.fileName || "");
          this.$set(this.embItem, "href", embItem.href || "");
          this.$set(this.embItem, "embSize", embItem.embSize || "");
          this.$set(this.embItem, "embContent", embItem.embContent);
          this.$set(this.embItem, "uploadContent", embItem.file ? true : false);
          cItem.embList.push(JSON.parse(JSON.stringify(this.embItem)));
        });
      });
    },
    // 编辑撞色数据
    handleEditContrastData(detailList) {
      this.categoryList.map(cItem => {
        detailList.map(dItem => {
          if (!dItem.contrastSaveList) return false;
          if (cItem.id === dItem.clothCategory) {
            cItem.contrastSaveList.map((embItem, embIndex) => {
              dItem.contrastSaveList.map(embVal => {
                this.$set(embItem, "site", embVal.site);
                this.$set(embItem, "color", embVal.color);
              });
            });
          }
        });
      });
    },
    // 编辑尺码数据
    handleEditSizeData(detailList) {
      let tunwei = null
      if (this.submitData.sizeCategoryId !== 10054) {
        detailList.map(dItem => {
          this.sizeList.map(sItem => {
            if (dItem.clothCategory === sItem.id) {
              this.$set(sItem, "value", dItem.styleId);
              dItem.sizeList.map(sizeReturnItem => {
                sItem.sizeList.map(sizeRenderItem => {
                  if (sizeRenderItem.id === sizeReturnItem.partId) {
                    this.$set(
                      sizeRenderItem,
                      "inputValue",
                      sizeReturnItem.partValue
                    );
                  }
                });
              });
            }
            dItem.sizeList.map(sizeReturnItem => {
              if (tunwei) {
                sItem.sizeList.map(sizeRenderItem => {
                  if (sizeRenderItem.id === 10108) {
                    this.$set(
                      sizeRenderItem,
                      "inputValue",
                      tunwei
                    );
                  }
                });
                return false
              }
              if (sizeReturnItem.partId === 10108) {
                tunwei = sizeReturnItem.partValue
              }
              sItem.sizeList.map(sizeRenderItem => {
                if (sizeRenderItem.id === 10108) {
                  this.$set(
                    sizeRenderItem,
                    "inputValue",
                    tunwei
                  );
                }
              });
            });
          });
        });
      } else {
        detailList.map(dItem => {
          this.sizeList.map(sItem => {
            if (dItem.clothCategory === sItem.id) {
              this.$set(sItem, "sizeVal", Number(dItem.shape));
              sItem.sizeList.map(sizeItem => {
                if (sizeItem.id === sItem.sizeVal) {
                  this.$set(sItem, "details", sizeItem.details);
                  dItem.sizeList.map(returnSizeItem => {
                    // 编辑返回的尺码数据
                    sizeItem.details.map(renderSizeItem => {
                      if (returnSizeItem.partId === renderSizeItem.id) {
                        this.$set(
                          renderSizeItem,
                          "inputValue",
                          returnSizeItem.partValue
                        );
                      }
                    });
                  });
                }
                // if(sItem.id!==2000) return false
                // if(dItem.clothCategory!==3) return false
                dItem.sizeList.map(sizeReturnItem => {
                  if (tunwei) {
                    sItem.sizeList.map(sizeRenderItem => {
                      if (sizeRenderItem.id === 10108) {
                        this.$set(
                          sizeRenderItem,
                          "inputValue",
                          tunwei
                        );
                      }
                    });
                    return false
                  }
                  if (sizeReturnItem.partId === 10108) {
                    tunwei = sizeReturnItem.partValue
                  }
                  sItem.sizeList.map(sizeRenderItem => {
                    if (sizeRenderItem.id === 10108) {
                      this.$set(
                        sizeRenderItem,
                        "inputValue",
                        tunwei
                      );
                    }
                  });
                });
              });
            }
          });
        });
        console.log(this.sizeList)
      }
    },
    // 根据浏览器语言设置默认身高单位
    handleSetUnit() {
      this.lang = getBrowserLang();
      let fitHeight = this.basicList.find(item => {
        return item.suitKey && item.suitKey === "heightUnit";
      });
      let fitWeight = this.basicList.find(item => {
        return item.suitKey && item.suitKey === "weightUnit";
      });
      if (this.lang === "zh") {
        this.unit.heightUnitName = "厘米";
        this.unit.heightUnit = 10266;
        this.unit.weightUnitName = "千克";
        this.unit.weightUnit = 10261;
      } else {
        this.unit.heightUnitName = "cm";
        this.unit.heightUnit = 10266;
        // this.unit.fitWeightName = 'pound'
        // this.unit.weightUnit = 10260;
        this.unit.weightUnitName = "kg";
        this.unit.weightUnit = 10261;
      }
      this.$set(fitHeight, "suitVal", this.unit.heightUnit);
      this.$set(fitWeight, "suitVal", this.unit.weightUnit);
    },
    async getCategoryList() {
      try {
        let {data} = await getCategory({
          orderWay: 8
        });
        if (data.code === 0) {
          this.plList = data.data;
        }
      } catch (error) {
      }
    },
    async handlePlChange(id) {
      this.handlePlData();
      this.$router.push(`peofessionalOrder?id=${id}`);

    },
    // 获取当前品类的配置
    handlePlData() {
      this.handleSubmitCraft();
      this.handleSubmitEmbs();
      this.handleSubmitContrast();
      this.handleSubmitCustomer();
      this.handleSubmitSize();
      this.handleSubmitSpecBody();
      this.plData.detailList = this.detailList;
      this.plData = Object.assign(this.plData, this.customer);

    },
    // 获取当前品类的配置
    handlePlData() {
      if (this.categoryList.length > 0) {
        this.categoryList.map(item => {
          let curIten = this.detailList.find(ditem => ditem.clothCategory === item.id)
          curIten.craftList = item.craftList
        })
      }
      this.handleSubmitEmbs();
      this.handleSubmitContrast();
      this.handleSubmitCustomer();
      this.handleSubmitSize();
      this.handleSubmitSpecBody();
      const detailList = this.removeDuplicate(this.detailList.concat(this.plData.detailList))
      this.plData = {
        orderId: this.$route.query.orderId,
        orderCode: this.orderCode,
        cid: this.$route.query.id,
        ...this.submitData,
        detailList: detailList,
        ...this.customer,
        heightUnitName: this.unit.heightUnit === 10266 ? '厘米' : this.unit.heightUnit === 10265 ? '英寸' : '',
        weightUnitName: this.unit.weightUnit === 10261 ? '千克' : this.unit.weightUnit === 10262 ? '磅' : ''
      };


      sessionStorage.setItem("plData", JSON.stringify(this.plData));
    },
    removeDuplicate(arr) {
      const newArr = []
      const obj = {}

      arr.forEach(item => {
        if (!obj[item.clothCategory]) {
          newArr.push(item)
          obj[item.clothCategory] = true
        }
      })

      return newArr
    },
    handleEmptyFabricList() {
      this.fabricList = [];
    },
    throttle(fn, delay) {
      let timer = null;
      return () => {
        if (timer) return;
        timer = setTimeout(() => {
          fn();
          clearTimeout(timer);
          timer = null;
        }, delay);
      };
    }
  },
  mounted() {
    this.getCategoryList();
    this.routeParams = getParams(this.$route.fullPath);
    this.plVal = Number(this.routeParams.id);
    this.handleSetUnit();
    if (this.routeParams.orderId) {
      this.submitData.sizeCategoryId = Number(this.routeParams.sizeCategoryId);
      if (this.routeParams.orderType !== "buyagain") {
        this.submitData.orderId = this.routeParams.orderId;
      }
    }
    this.getData();
    window.addEventListener(
      "scroll",
      this.throttle(() => {
        const scrollY = window.scrollY;
        if (scrollY > 120) {
          this.fixedActionShow = true;
        } else {
          this.fixedActionShow = false;
        }
      }, 200)
    );
  },
  destroyed() {
    sessionStorage.removeItem("plData");
  },
  beforeRouteUpdate(to, from, next) {
    next();
    window.location.reload();
  }
};



// WEBPACK FOOTER //
// ./src/views/peofessionalOrder/peofessionalOrder.js